module.exports = __webpack_public_path__ + "static/office_outside_view-a16a3cc7e25415a996eb62797b3d7541.jpg";